import React, { Component } from 'react';
import MissingComponent from './MissingComponent';
import FilePlotComponent from './FilePlotComponent';
import FilePlotsComponent from './FilePlotsComponent';
import GraphComponent from './GraphComponent';
import MapComponent from './MapComponent';
import PlotComponent from './PlotComponent';
import PlotsComponent from './PlotsComponent';
import SankeyComponent from './SankeyComponent';
import StatComponent from './StatComponent';
import TableComponent from './TableComponent';
import KPIComponent from './KPIComponent';
import DownloadComponent from './DownloadComponent';
import AlertTableComponent from './AlertTableComponent';
import DataUseCaseComponent from './DataUseCaseComponent';
import SupersetDemo from "./SupersetDemo/SupersetDemo";

class ReportComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      exists: true,
      isRendered: false,
      type: null,
      data: null
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.props.onComponentLoad();
  }

  componentDidMount() {
    if (this.props.isActive) {
      if (this.props.reportComponentIsMissing) {
        this.setState({
          type: this.props.reportComponentDataType
        });
      } else {
        this.fetchAndUpdate();
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.exists === true && nextState.exists === false) {
      return true;
    }

    if (
      nextProps.isActive === this.props.isActive &&
      nextState.type === this.state.type &&
      nextState.data === this.state.data
    ) {
      return false;
    }

    if (nextProps.isActive) {
      // Do we have data already (checking for type to verify)?
      if (nextState.type) {
        // Has this been rendered already?
        if (nextState.isRendered) {
          // No need to render the component; it has been rendered already
          return false;
        } else {
          this.setState({
            isRendered: true
          });
          // Render the component
          return true;
        }
      } else {
        // If not, fetch them and update the state when done
        if (this.props.reportComponentIsMissing) {
          this.setState({
            type: this.props.reportComponentDataType
          });
        } else {
          this.fetchAndUpdate();
        }

        // No need to render the component since we don't have data yet
        return false;
      }
    } else {
      return false;
    }
  }

  fetchAndUpdate() {
    fetch(
      `${this.props.apiEndpoint}component/${this.props.reportComponentId}${
        !this.props.reportVersionString ||
        this.props.reportVersionString === 'latest'
          ? ``
          : `/dver/${this.props.reportVersionString}`
      }`,
      {
        credentials: 'include'
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(json => {
          const {
            data_type,
            data,
            info_text,
            is_missing,
            missing_text,
            title,
            show_as_timeseries,
            contains_overall_values
          } = json;

          let showAsTimeseries = false;

          if (show_as_timeseries) {
            let parsedData = data;
            if (typeof data === 'string') {
              try {
                parsedData = JSON.parse(data);
              } catch (e) {
                console.error("Invalid JSON string in 'data'", data);
                parsedData = {};
              }
            }
            showAsTimeseries = parsedData && parsedData.data && parsedData.data.length > 0;
          }
          this.setState({
            type: data_type,
            data,
            infoText: info_text,
            isMissing: is_missing,
            missingText: missing_text,
            title,
            showAsTimeseries,
            containsOverallValues: contains_overall_values
          });
        });
      } else {
        this.setState({ exists: false });
      }
    });
  }

  render() {
    // This is here to avoid the initial render without data,
    // since shouldComponentUpdate() is not called in that case
    if (!this.state.exists || !this.state.type) {
      return null;
    }

    const {
      type,
      data,
      infoText,
      isMissing,
      missingText,
      title,
      showAsTimeseries,
      containsOverallValues,
    } = this.state;

    const componentProps = {
      id: this.props.reportComponentId,
      columns: this.props.reportComponentColumns,
      heightInPx: this.props.reportComponentHeightInPx,
      data,
      title,
      info: infoText,
      isMissing,
      missingText,
      isActive: this.props.isActive,
      lastUpdated: this.props.reportLastUpdated,
      showAsTimeseries,
      containsOverallValues
    };

    if (isMissing && type !== 'Stat') {
      return <MissingComponent {...componentProps} />;
    }

    switch (type) {
      case 'Stat':
        return <StatComponent {...componentProps} />;

      case 'Plot':
        return <PlotComponent {...componentProps} />;

      case 'FilePlot':
        return <FilePlotComponent {...componentProps} />;

      case 'PlotArray':
        return <PlotsComponent {...componentProps} />;

      case 'FilePlotArray':
        return <FilePlotsComponent {...componentProps} />;

      case 'Table':
        return <TableComponent {...componentProps} />;

      case 'Map':
        return <MapComponent {...componentProps} />;

      case 'Graph':
        return <GraphComponent {...componentProps} />;

      case 'Sankey':
        return <SankeyComponent {...componentProps} />;

      case 'KPI':
        return <KPIComponent {...componentProps} />;

      case 'Download':
        return <DownloadComponent {...componentProps} />;

      case 'AlertTable':
        return <AlertTableComponent {...componentProps} />;

      case 'DataUseCase':
        return <DataUseCaseComponent {...componentProps} />;

      case 'Superset':
        return <SupersetDemo {...componentProps} />;

      default:
        return null;
    }
  }
}

export default ReportComponent;
